<div class="form-group row">
  <label class="col-sm-4 col-form-label">{{title}}</label>
  <div class="col-sm-2">
    <ui-switch color="#c89712" [(ngModel)]="value" (change)="updateValue($event)" [disabled]="disabled"></ui-switch>
  </div>
  <label class="col-sm-2">{{secondTitle}}</label>
  <div *ngIf="secondTitle" class="col-sm-2">
    <ui-switch color="#c89712" [(ngModel)]="secondValue" (change)="updateSecondValue($event)" [disabled]="disabled"></ui-switch>
  </div>
</div>
